import { UserOccupation } from '../types';
import { FieldTypes, WebEntity } from './types';

const UserOccupationEntity: WebEntity<UserOccupation> = {
  name: 'userOccupation',
  endpoint: 'userOccupation',
  referenceColumn: 'userOccupationName',
  customButtonNames: {
    addButtonName: 'Agregar Ocupacion'
  },
  customDataActions: {
    addModalTitle: 'Agregar la Ocupacion',
    editModalTitle: 'Editar la Ocupacion'
  },
  tableColumns: [
    {
      header: 'ID',
      accessorKey: '_id',
      omitExport: true,
      columnType: 'text',
      enableHiding: false,
      visibleInShowHideMenu: false
    },
    {
      header: 'Ocupacion',
      accessorKey: 'userOccupationName',
      columnType: 'text'
    }
  ],

  fields: [
    {
      name: 'Ocupacion',
      selector: 'userOccupationName',
      type: FieldTypes.Text,
      required: true
    }
  ],

  editableFields: [
    {
      name: 'Ocupacion',
      selector: 'userOccupationName',
      type: FieldTypes.Text,
      required: true
    }
  ]
};

export default UserOccupationEntity;
